import {useEffect} from 'react';

import {POST_AUTH_TAG} from '../constants';

const useCreateGoogleTagManagerScript = (id = 'google-tag-manager', tagId = POST_AUTH_TAG) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.id = id;
    script.type = 'text/javascript';
    script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${tagId}');`;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);
};

export default useCreateGoogleTagManagerScript;
